<template>
  <div id="videos_news_outer" class="container">
    <div id="videos_menu">
      <a v-for="(item, index) in tabList" :class="[tabIndex == index ? 'active' : '']"
         :href="menuPath(index)"
      >{{item}}</a>
    </div>
    <div id="video_news_content" class="row" v-if="itemList != null">

      <div v-if="itemList.length > 0 ">
        <a class="col-xs-12 col-sm-6 col-md-4"
           :href="itemSrc(item)"
           target="_blank"
           v-for="(item, index) in itemList">
          <div class="video-item">
            <img class="video-cover" :src="posterImg(item)">
            <div>{{item.actionTitle}}</div>
            <img class="video-play-button" src="../../assets/shl_news_center_video_play.png">
          </div>
        </a>
      </div>
      <div v-else style="font-size: 1.5rem;padding-top: 120px;text-align: center;">
        暂无内容
      </div>
    </div>
    <div style="padding-right: 30px;">
      <bottom-paginator
        v-bind:current="pageIndex"
        v-bind:total="totalPage"
        v-bind:paginator-type="1"
        v-on:itemClicked="paginatorClicked"
      />
    </div>
  </div>
</template>

<script>
import GlobalInstance from "../../js/shba";
import BottomPaginator from "../BottomPaginator";

export default {
  name: "VideoNewsList",
  components: {
    BottomPaginator
  },
  data() {
    return {
      title: '精彩视频',

      tabList: [
        '全部',
        '赛事',
        '培训'
      ],

      itemList: [],
      pageIndex: 1,
      size: 10,
      count: 0,
      isLoading: false,
    }
  },
  computed: {
    tabIndex() {
      let index = this.$route.params.index;
      return index != undefined ? index - 1 : 0;
    },
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    },
    menuId() {
      return GlobalInstance.methods.currentSubTabId(this.$route);
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    menuPath(index) {
      let item = this.currentMenuItem;
      let path = item.src + '/' + this.menuId + '/' + (index + 1);
      path += '#videos_menu'
      return path;
    },

    paginatorClicked(event) {
      let index = event.index;
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      if (this.isLoading) {
        return;
      }
      let pageIndex = this.pageIndex;
      let tag = this.tabList[this.tabIndex];
      let params = {
        pageIndex,
        size: this.size,
        type: 2,
        tag
      };
      this.isLoading = true;
      let _this = this;
      this.$store.state.http.ajax.vmActivities(params,function (data) {
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          _this.count = data.count;
          _this.itemList = newList;
          return;
        }

        _this.$toast('请求失败！');

      },function (data) {
        _this.isLoading = false;
        _this.$toast('请求失败，请重试！');
      });
    },
    itemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0303/0/' + item.id;
    },

    posterImg(item) {
      let imageUrls = item.imageUrls;
      if (imageUrls != null && imageUrls.length > 0) {
        let pic = imageUrls.split('?')[0];
        return pic
      }
      return '';
    }
  }
}
</script>

<style scoped>

  #videos_news_outer {
    width: 100%;
    padding: 0;
  }

  #videos_menu {
    flex-direction: row;
    padding: 0;

  }

  #videos_menu a {
    color: #333;
    font-size: 1.5rem;
    font-weight: bold;
    padding: 5px 0;
    /*display: inline-block;*/
    text-decoration: none;
  }

  #videos_menu a.active {
    color: #fc1a34;
    border-bottom: solid 3px #fc1a34;
    pointer-events: none;
  }

  #videos_menu a:hover {
    color: #fc1a34;
  }

  #videos_menu a:not(:first-child) {
    margin-left: 30px;
  }

  #video_news_content {
    width: 100%;
    min-height: 300px;
  }

  #video_news_content a {
    text-decoration: none;
    margin-top: 30px;
    display: inline-block;
  }

  .video-item {
    position: relative;
    width: 100%;
  }

  .video-item .video-cover {
    width: 100%;
    height: auto;
    border-radius: 6px;
  }

  .video-item .video-play-button {
    width: 10%;
    height: auto;
    position: absolute;
    top: 40%;
    left: 45%;
     max-width: 23px;

  }

  .video-item div {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 5px;

    background-color: rgba(0,0,0,0.3);
    color: white;
    font-size: 1rem;
    text-align: center;
    line-height: 1.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/news/VideoNewsList.vue